<template>
<ObservationRecordOrganism v-if="record.recordType === 'organism'" :record="record"></ObservationRecordOrganism>

    <div v-else class="row observation-record-item">
        <div class='col-12 pt-1'
            v-if='["textarea", "text", "number", "dropdown", "radio", "datetime", "location", "multiple_choice"].includes(record.recordType)'>
            <div class=" font-weight-bold text-muted" v-if="!record.description">
                {{ record.label }}
                <PrivateTooltip v-if="record.isPrivate" />
            </div>
            <div v-else class="font-weight-bold text-muted">
                {{ record.label }}
                <PrivateTooltip v-if="record.isPrivate" />
                <i v-b-tooltip.hover.top :title="record.description" class="fa fa-question-circle ml-2 user-select-none"
                    style="cursor: pointer"></i>
            </div>
        </div>

        <div class="col-12 font-weight-bold pb-1 border-bottom"
            v-if='["textarea", "text", "number"].includes(record.recordType)'>
            {{ record.value }}
        </div>
        <div class="col-12 font-weight-bold pb-1 border-bottom" v-if='["dropdown", "radio"].includes(record.recordType)'>
            {{ record.value || record.optionValue.value }}
        </div>
        <div class="col-12 font-weight-bold pb-1 border-bottom" v-if='["multiple_choice"].includes(record.recordType)'>
            {{record.value || record.multiSelectOptionValues.map(val => val.value)}}
        </div>
        <div class="col-12 font-weight-bold pb-1 border-bottom" v-if='["datetime"].includes(record.recordType)'>
            {{ recordDate }}
        </div>
        <div class="col-12 py-2 font-weight-bold bg-light " v-if='record.recordType === "image"'>
            <div>
                <div class="text-secondary pb-1" v-if="!record.description">
                    {{ record.label }}
                    <PrivateTooltip v-if="record.isPrivate" />
                </div>
                <div class='text-dark pb-1' v-else>
                    {{ record.label }}
                    <PrivateTooltip v-if="record.isPrivate" />
                    <i v-b-tooltip.hover.top :title="record.description" class="fa fa-question-circle ml-2 user-select-none" style="cursor: pointer"></i>
                </div>
            </div>
            <b-img v-for="file in record.files" :key="file.id" fluid thumbnail style='max-height: 400px;'
                :src="file.path" left alt="`${record.label}. ${record.description}`" />

    </div>
</div>
</template>

<script>
import ObservationRecordOrganism from "./ObservationRecordOrganism.vue";
import PrivateTooltip from "../../components/common/PrivateTooltip.vue";
export default {
    name: "observation-record-item-view",
    components: {
        ObservationRecordOrganism,
        PrivateTooltip
    },
    props: {
        record: {
            type: Object,
            required: true,
        },
    },
    computed: {
        recordDate() {
            return moment(this.record.value.split("+")[0]).format("MMMM DD, YYYY h:mm:ss a")
        }
    }
};
</script>
